<template>
	<div>
		<div class="page-title"><span>{{$store.state.lang.text.contact[$store.state.lang.language]}}</span></div>
		<div class="md-layout" style="margin-top: 15px;">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-33 text-center" style="margin-bottom: 15px;">
				<p style="text-align: center;"><a href="tel:+85510819898"><img src="@/assets/img/socials/phone.png" style="margin-bottom: 10px"></a></p>
				<p style="text-align: center;"><a href="tel:+85510819898">010 81 9898 / 068 81 9898</a></p>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-33 text-center" style="margin-bottom: 15px;">
				<p style="text-align: center;"><a href="https://t.me/bet_98M"><img src="@/assets/img/socials/telegram.png" style="margin-bottom: 10px"></a></p>
				<p style="text-align: center;"><a href="https://t.me/bet_98M">98MBET Telegram</a></p>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-33 text-center" style="margin-bottom: 15px;">
				<p style="text-align: center;"><a href="https://www.facebook.com/98mbet"><img src="@/assets/img/socials/facebook.png" style="margin-bottom: 10px"></a></p>
				<p style="text-align: center;"><a href="https://www.facebook.com/98mbet">98MBET Facebook</a></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
		},
		methods: {
		},
		computed: {
		},
		data() {
			return {
				loaded: false
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Page/Contact.vue